/* Patriot Sports — Rebuild Preview behaviour */
(function () {
  'use strict';

  /* ---------- mega menu (hover + keyboard) ---------- */
  document.querySelectorAll('.pt-nav > li.has-mega').forEach(function (li) {
    var t;
    li.addEventListener('mouseenter', function () {
      t = setTimeout(function () { li.classList.add('is-open'); }, 120);
    });
    li.addEventListener('mouseleave', function () {
      clearTimeout(t); li.classList.remove('is-open');
    });
    var btn = li.querySelector('button');
    if (btn) {
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var open = li.classList.contains('is-open');
        document.querySelectorAll('.pt-nav > li').forEach(function (o) { o.classList.remove('is-open'); });
        if (!open) li.classList.add('is-open');
        btn.setAttribute('aria-expanded', String(!open));
      });
    }
    li.addEventListener('focusout', function (e) {
      if (!li.contains(e.relatedTarget)) li.classList.remove('is-open');
    });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('.pt-nav > li').forEach(function (o) { o.classList.remove('is-open'); });
  });

  /* ---------- mobile drawer ---------- */
  var drawer = document.querySelector('.pt-drawer');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.style.overflow = open ? 'hidden' : '';
  }
  document.querySelectorAll('[data-pt-drawer-open]').forEach(function (b) {
    b.addEventListener('click', function () { setDrawer(true); });
  });
  document.querySelectorAll('[data-pt-drawer-close]').forEach(function (b) {
    b.addEventListener('click', function () { setDrawer(false); });
  });

  /* ---------- accordions (drawer + PDP) ---------- */
  document.querySelectorAll('.pt-acc > button, .pt-acc2 > button').forEach(function (b) {
    b.addEventListener('click', function () {
      var p = b.parentElement;
      var open = p.classList.toggle('is-open');
      b.setAttribute('aria-expanded', String(open));
    });
  });

  /* ---------- sticky mobile CTA ---------- */
  var sticky = document.querySelector('.pt-sticky');
  var hero = document.querySelector('.pt-hero, .pt-sport-hero, .pt-pdp');
  if (sticky && hero && 'IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting); });
    }, { rootMargin: '-120px 0px 0px 0px' }).observe(hero);
  } else if (sticky) {
    sticky.classList.add('is-on');
  }

  /* ---------- design family filter ---------- */
  document.querySelectorAll('[data-pt-filter-group]').forEach(function (group) {
    var targets = document.querySelectorAll('[data-pt-filter-item]');
    group.querySelectorAll('button').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = b.dataset.value || 'all';
        group.querySelectorAll('button').forEach(function (o) { o.setAttribute('aria-pressed', String(o === b)); });
        targets.forEach(function (el) {
          var tags = (el.dataset.ptFilterItem || '').split(',');
          el.style.display = (v === 'all' || tags.indexOf(v) > -1) ? '' : 'none';
        });
      });
    });
  });

  /* ---------- PDP gallery ---------- */
  var gal = document.querySelector('[data-pt-gallery]');
  if (gal) {
    var stage = gal.querySelector('[data-pt-stage]');
    gal.querySelectorAll('[data-pt-thumb]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (stage) { stage.src = b.dataset.full; stage.alt = b.dataset.alt || ''; }
        gal.querySelectorAll('[data-pt-thumb]').forEach(function (o) { o.setAttribute('aria-current', String(o === b)); });
      });
    });
  }

  /* ---------- team store finder ---------- */
  var finderInput = document.querySelector('[data-pt-store-search]');
  if (finderInput) {
    var list = document.querySelector('[data-pt-store-list]');
    var countEl = document.querySelector('[data-pt-store-count]');
    var emptyEl = document.querySelector('[data-pt-store-empty]');
    var cards = list ? [].slice.call(list.querySelectorAll('[data-pt-store]')) : [];
    function renderCount(n) {
      if (countEl) countEl.textContent = n + (n === 1 ? ' store' : ' stores');
      if (emptyEl) emptyEl.hidden = n !== 0;
    }
    function filterStores() {
      var q = finderInput.value.trim().toLowerCase();
      var shown = 0;
      cards.forEach(function (c) {
        var hit = !q || (c.dataset.ptStore || '').indexOf(q) > -1;
        c.style.display = hit ? '' : 'none';
        if (hit) shown++;
      });
      renderCount(shown);
    }
    finderInput.addEventListener('input', filterStores);
    renderCount(cards.length);
  }

  /* ---------- THE PRICE LADDER ---------- */
  var ladder = document.querySelector('[data-pt-ladder]');
  if (ladder) {
    var tiers = [];
    try { tiers = JSON.parse(ladder.dataset.ptLadder || '[]'); } catch (err) { tiers = []; }
    if (tiers.length) {
      var money = ladder.dataset.symbol || '$';
      var range = ladder.querySelector('[data-pt-range]');
      var priceEl = ladder.querySelector('[data-pt-price]');
      var totalEl = ladder.querySelector('[data-pt-total]');
      var saveEl = ladder.querySelector('[data-pt-save]');
      var stickyPrice = document.querySelector('[data-pt-sticky-price]');
      var btns = ladder.querySelectorAll('[data-pt-tier]');
      var base = parseFloat(tiers[0].price);

      function fmt(n) {
        return money + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }
      function apply(i) {
        i = Math.max(0, Math.min(tiers.length - 1, i));
        var t = tiers[i];
        var unit = parseFloat(t.price);
        var qty = parseInt(t.qty, 10);
        if (priceEl) priceEl.textContent = fmt(unit);
        if (totalEl) totalEl.innerHTML = '<b>' + qty + '</b> units &nbsp;·&nbsp; <b>' + fmt(unit * qty) + '</b> total';
        if (saveEl) {
          var pct = Math.round((1 - unit / base) * 100);
          if (pct > 0) { saveEl.textContent = 'Save ' + pct + '% vs 12 units'; saveEl.hidden = false; }
          else { saveEl.hidden = true; }
        }
        if (stickyPrice) stickyPrice.textContent = fmt(unit) + ' ea at ' + qty;
        btns.forEach(function (b, bi) { b.setAttribute('aria-pressed', String(bi === i)); });
        if (range && parseInt(range.value, 10) !== i) range.value = i;
      }
      if (range) {
        range.max = String(tiers.length - 1);
        range.addEventListener('input', function () { apply(parseInt(range.value, 10)); });
      }
      btns.forEach(function (b, bi) { b.addEventListener('click', function () { apply(bi); }); });
      apply(0);
    }
  }
})();
